import { Action } from "redux";

export const WFS_3D_LAYER_RELOAD = "WFS_3D_LAYER_RELOAD";

export const wfs3dLayerReloadAction = (): Action => {
    return {
        type: WFS_3D_LAYER_RELOAD,
    };
};
